import { useEffect, useState } from "react";
import { _single, _SystemPropertyOB } from "../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { DocumentationButton } from "./Buttons/IAButton/DocumentationButton"
import { HelpButtom } from "./Buttons/HelpButtom/HelpButtom"
import { ChatButtonAI } from "./Buttons/IAButton/ChatButtonAI";

export const TopButtons = () => {

    const propertie = useDataBean(_SystemPropertyOB);
    const [idAdmin, setIDAdmin] = useState<number>();

    useEffect(() => {
        getProperty();
        console.log(_single.getAccountID())
    }, [])

    const getProperty = () => {
        let cache = _single.getCacheItem("AdmindID");
        if (cache) {
            setIDAdmin(cache)
            console.log(cache)
        } else {
            propertie.instance.getSystemProperty("AdmindID").then(
                (resp) => {
                    _single.setCacheItem("AdmindID", resp.SystemValue);
                    setIDAdmin(resp.SystemValue)
                }
            ).catch(err => { console.log(err) })
        }
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <div className="d-flex flex-row-reverse gap-2" style={{ marginTop: -15 }}>
                    <div>
                        <HelpButtom />
                    </div>
                    <div className="div">
                        <DocumentationButton canEdit={_single.getAccountID() == idAdmin} />

                    </div>
                    <div className="div">
                        <ChatButtonAI />
                    </div>
                </div>
            </div>
        </div>
    )
}